import React, { useContext, useEffect, useState } from 'react'
import { IMaskInput } from 'react-imask'
import { CalculatorContext } from '../context'

const Calculator = ({ price, permissibleValues }) => {
  const [carat, setCarat] = useState('')
  const [placeholder, setPlaceholder] = useState('0')
  const [totalPrice, setTotalPrice] = useState('- || -')

  const { calculatorIsShow, onCalculatorHideClick } = useContext(CalculatorContext)

  useEffect(() => {
    setCarat('')
  }, [placeholder])

  useEffect(() => {
    setPlaceholder(Object.keys(permissibleValues).length ? `${permissibleValues.min.toString().replace('.', ',')} - ${permissibleValues.max.toString().replace('.', ',')}` : '0')
    if (carat.replace(',', '.') >= permissibleValues.min && carat.replace(',', '.') <= permissibleValues.max) {
      setTotalPrice(String((carat.replace(',', '.') * price).toFixed(0)))
    } else {
      setTotalPrice('- || -')
    }
  }, [carat, price, permissibleValues])

  return (
    <div className={`price__calculator ${calculatorIsShow ? 'price__calculator--is-show' : ''}`} >
      <button className='price__calculator-close' onClick={onCalculatorHideClick} />
      <p className='price__calculator-title'>Калькулятор</p>
      <IMaskInput
        mask={Number}
        radix=','
        mapToRadix={['.']}
        min={Number(permissibleValues.min)}
        max={Number(permissibleValues.max)}
        value={carat}
        onAccept={
          (value) => setCarat(value)
        }
        placeholder={placeholder}
        className='price__calculator-input'
        disabled={!Object.keys(permissibleValues).length}
      />
      <p className='price__calculator-description'>{Object.keys(permissibleValues).length ? `Введите значение массы бриллианта в диапазоне ${permissibleValues.min.toString().replace('.', ',')}-${permissibleValues.max.toString().replace('.', ',')}.` : 'Выберите бриллиант из прайса'}</p>
      <span className='price__calculator-price'>{price}</span>
      <p className='price__calculator-description'>Цена за карат</p>
      <span className='price__calculator-price'>{totalPrice}</span>
      <p className='price__calculator-description'>Стоимость вашего бриллианта, $</p>
    </div>
  )
}

export default Calculator
